export default [
  { label: 'Season', key: 'seasonName' },
  { label: 'WeekNumber', key: 'weekNo' },
  { label: 'EventName', key: 'eventName' },
  { label: 'Division', key: 'division' },
  { label: 'Pos', key: 'pos' },
  { label: 'TeamName', key: 'teamName' },
  { label: 'Base', key: 'base' },
  { label: 'TMS', key: 'tms' },
  { label: 'Total', key: 'total' }
]


// WEBPACK FOOTER //
// ./src/components/pages/Report/constants/pointsByEventHeaders.js